<template>
  <v-stepper v-model="stage">
    <v-stepper-header>
      <v-stepper-item
        :complete="stage > 1"
        :value="1"
        color="#004e8f"
        title="Welcome to the Deposit Service"
      />
      <v-divider />

      <v-stepper-item
        :complete="stage > 2"
        :value="2"
        color="#004e8f"
        title="Before you start"
      />
      <v-divider />

      <v-stepper-item
        :value="3"
        color="#004e8f"
        title="Data protection"
      />
    </v-stepper-header>

    <v-stepper-window class="mb-4">
      <v-stepper-window-item :value="1">
        <v-card class="mb-12">
          <v-card-text class="rich-text">
            <p>This is an online service for transferring digital files to Cambridge University Libraries safely and securely.</p>

            <p>This online service can only be used by depositors authorised by Cambridge University Libraries.</p>


            <h3>If you have not already been authorised to use the Deposit Service please email <a href="mailto:digitalpreservationservice@lib.cam.ac.uk">digitalpreservationservice@lib.cam.ac.uk</a> to request access.</h3>
            <br>
            <p>Cambridge University Libraries welcome offers of material that complement or extend their collections.</p>
            <p>
              Further information about the <a
                href="https://www.lib.cam.ac.uk/about-library/library-management/policies"
                target="_blank"
              >collecting policy</a> is available online.
            </p>
            <p>If you experience issues with accessibility using this service, please contact <a href="mailto:digitalpreservationservice@lib.cam.ac.uk">digitalpreservationservice@lib.cam.ac.uk</a> for assistance.</p>
            <br>
          </v-card-text>
        </v-card>

        <v-btn
          color="secondary"
          class="mx-2 text-white"
          @click="stage = 2"
        >
          <span title="Start now">START NOW</span>
        </v-btn>
      </v-stepper-window-item>

      <CookieNotice />

      <v-stepper-window-item
        :value="2"
        class="mb-4"
      >
        <BeforeYouStart />

        <v-btn
          color="secondary"
          class="mx-2 text-white"
          @click="stage = 3"
        >
          <span title="Continue">CONTINUE</span>
        </v-btn>

        <v-btn
          text
          class="mx-2"
          @click="stage = 1"
        >
          <span title="Go back">GO BACK</span>
        </v-btn>
      </v-stepper-window-item>

      <v-stepper-window-item
        :value="3"
        class="mb-4"
      >
        <DataProtection />

        <v-btn
          color="secondary"
          class="mx-2 text-white"
          @click="$router.push('/deposits')"
        >
          <span title="Continue">CONTINUE</span>
        </v-btn>

        <v-btn
          text
          class="mx-2"
          @click="stage = 2"
        >
          <span title="Go back">GO BACK</span>
        </v-btn>
      </v-stepper-window-item>
    </v-stepper-window>
  </v-stepper>
</template>

<script>
  import config from '@/config';
  import BeforeYouStart from '@/components/BeforeYouStart.vue';
  import CookieNotice from '@/components/CookieNotice.vue';
  import DataProtection from '@/components/DataProtection.vue';
  import '@/styles/rich-text.css'

  export default {
    name: 'WelcomePage',
    components: {
      BeforeYouStart,
      CookieNotice,
      DataProtection
    },
    data () {
      return {
        stage: 1,
        skipIntroName: config.skipIntroName
      }
    },
    methods: {
      skipIntro: function() {
        return localStorage.getItem(this.skipIntroName)
      },
      setSkipIntroTrue: function() {
        localStorage.setItem(this.skipIntroName, true)
        return true
      }
    }
  }
</script>
